import { gql } from '@apollo/client';

export const INFORMATION = gql`
    query informations($sort: InformationSortEnum) {
        informations(sort: $sort) {
            totalCount
            edges {
                node {
                    id
                    title
                    description
                    document {
                        url
                    }
                    status
                    informationType
                    sortingNumber
                    image {
                        url
                        contentType
                    }
                }
            }
        }
    }
`;
